<p-dialog
  [(visible)]="displayModal"
  modal="true"
  header="Edit Task"
  [style]="{ width: '50vw' }"
  [dismissableMask]="true"
>
  <form [formGroup]="taskForm">
    <div class="grid grid-cols-2 gap-4 p-4">
      <!-- Service Name -->
      <div>
        <label class="block text-gray-600 mb-1">Service Name</label>
        <input pInputText formControlName="serviceName" placeholder="Service Name" class="w-full" />
      </div>

      <!-- Client Name & Photo -->
      <div>
        <label class="block text-gray-600 mb-1">Client's Name & Photo</label>
        <div class="flex items-center gap-2">
          <img [src]="clientPhoto" alt="Client" class="w-8 h-8 rounded-full object-cover self-center" />
          <input pInputText formControlName="clientName"  class="w-full" />
        </div>
      </div>

      <!-- Due Date -->
      <div>
        <label class="block text-gray-600 mb-1">Due Date</label>
        <p-calendar formControlName="dueDate" showIcon="true" class="w-full" />
      </div>

      <!-- Status -->
      <div>
        <label class="block text-gray-600 mb-1">Status</label>
        <p-dropdown
          formControlName="status"
          [options]="statusOptions"
          placeholder="Select Status"
          class="w-full"
        ></p-dropdown>
      </div>

      <!-- Items -->
      <div>
        <label class="block text-gray-600 mb-1">Items</label>
        <p-dropdown
          formControlName="items"
          [options]="itemOptions"
          class="w-full"
        ></p-dropdown>
      </div>

      <!-- Total -->
      <div>
        <label class="block text-gray-600 mb-1">Total</label>
        <input pInputText formControlName="total"  class="w-full" />
      </div>

      <!-- Order ID -->
      <div class="col-span-2">
        <label class="block text-gray-600 mb-1">Order ID</label>
        <input pInputText formControlName="orderId"  class="w-full" />
      </div>
    </div>
  </form>

  <!-- Footer Buttons -->
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" (click)="closeModal.emit()"></p-button>
      <p-button label="Save" icon="pi pi-check" severity="primary" (click)="saveChanges()"></p-button>
    </div>
  </ng-template>
</p-dialog>
